import { formatCurrency } from '@web-platform/shared-universal-utils-frontend-localisation';

import { translate } from '../translate';

type SponsoredAriaLabelProps = {
  callToActionText?: string | null;
  price?: number | null;
  priceLabel?: string | null;
  title?: string;
  partnerName?: string;
  message?: string | null;
  noCtaText?: boolean;
};

export const sponsoredAriaLabel = ({
  callToActionText,
  message,
  noCtaText,
  partnerName,
  price,
  priceLabel,
  title,
}: SponsoredAriaLabelProps) => {
  const messageText = (() => {
    if (message && title) {
      return `${title}. ${message}`;
    }
    if (title) {
      return title;
    }
    return message ?? undefined;
  })();

  const priceText = (() => {
    if (price) {
      return translate('ktxtDayViewResults_PriceTotal', {
        price: formatCurrency(Math.ceil(price)),
      });
    }
    return priceLabel || undefined;
  })();

  const ctaText = callToActionText || translate('ktxt_select');
  const hasMessage = !!(message || title);
  const hasCta = !noCtaText;

  if (partnerName) {
    if (hasMessage && hasCta && priceText) {
      return translate('ktxt_a11y_sponsored_partner_message_price_cta', {
        partner: partnerName,
        message: messageText,
        price: priceText,
        cta: ctaText,
      });
    }
    if (hasMessage && hasCta) {
      return translate('ktxt_a11y_sponsored_partner_message_cta', {
        partner: partnerName,
        message: messageText,
        cta: ctaText,
      });
    }
    if (hasMessage) {
      return translate('ktxt_a11y_sponsored_partner_message', {
        partner: partnerName,
        message: messageText,
      });
    }
    if (hasCta && priceText) {
      return translate('ktxt_a11y_sponsored_partner_price_cta', {
        partner: partnerName,
        price: priceText,
        cta: ctaText,
      });
    }
    if (hasCta) {
      return translate('ktxt_a11y_sponsored_partner_cta', {
        partner: partnerName,
        cta: ctaText,
      });
    }
    return translate('ktxt_a11y_advertisement_by_scenic', {
      scenic: partnerName,
    });
  }

  if (hasMessage && hasCta && priceText) {
    return translate('ktxt_a11y_sponsored_message_price_cta', {
      message: messageText,
      price: priceText,
      cta: ctaText,
    });
  }
  if (hasMessage && hasCta) {
    return translate('ktxt_a11y_sponsored_message_cta', {
      message: messageText,
      cta: ctaText,
    });
  }
  if (hasMessage) {
    return translate('ktxt_a11y_sponsored_message', {
      message: messageText,
    });
  }
  if (hasCta && priceText) {
    return translate('ktxt_a11y_sponsored_price_cta', {
      price: priceText,
      cta: ctaText,
    });
  }
  if (hasCta) {
    return translate('ktxt_a11y_sponsored_cta', {
      cta: ctaText,
    });
  }
  return translate('ktxtInlineAdSponsored');
};
